import serverConfig from '@common/server-config-context/server-config';
export var ConstituentDialogSteps;
(function (ConstituentDialogSteps) {
    ConstituentDialogSteps[ConstituentDialogSteps["TRIAL"] = 0] = "TRIAL";
    ConstituentDialogSteps[ConstituentDialogSteps["FORM"] = 1] = "FORM";
})(ConstituentDialogSteps || (ConstituentDialogSteps = {}));
export function getConstituentDialogFirstStep(constituentLicense, plan) {
    const allowSelfServiceTrial = serverConfig.hasFeature('allowSelfServiceTrial');
    const allowSelfServiceTrialPrepaid = serverConfig.hasFeature('allowSelfServiceTrialPrepaid');
    if (allowSelfServiceTrialPrepaid) {
        return constituentLicense.trial.state === 'AVAILABLE' && allowSelfServiceTrial
            ? ConstituentDialogSteps.TRIAL
            : ConstituentDialogSteps.FORM;
    }
    return constituentLicense.trial.state === 'AVAILABLE' &&
        plan === 'POSTPAID' &&
        allowSelfServiceTrial
        ? ConstituentDialogSteps.TRIAL
        : ConstituentDialogSteps.FORM;
}
